@if (reasoningSteps.length > 0) {
    <hive-accordion>
        <hive-accordion-tab heading="Reasoning" itemId="reasoning" [isOpen]="isLoading">
            <div class="reasoning-tab-content">
                @for (reasoning of reasoningSteps; track $index) {
                    @let shouldHighlight = isLoading && $last;
                    <div class="reasoning-step">
                        <div class="step-indicator" [class.spinning]="shouldHighlight">
                            <hive-icon-component [icon]="shouldHighlight ? faSpinner : faCheck" size="small" />
                        </div>
                        <div class="step-content" [class.highlighted-reasoning]="shouldHighlight">
                            {{ reasoning }}
                        </div>
                        <div class="step-connector"></div>
                        <div class="blank-step-space"></div>
                    </div>
                }
            </div>
        </hive-accordion-tab>
    </hive-accordion>
}
